import { createEmptyState } from 'data/createRandomState';
import { SAVE_SETTINGS } from 'constants/actionTypes';
import { saveSettings } from 'utils/stateToState';

export default function settings(state = createEmptyState().settings, action) {
  switch (action.type) {
    case SAVE_SETTINGS: {
      const { settings } = action;
      return saveSettings(state, settings);
    }
    default:
      return state;
  }
}
